import { Head, Link } from "@inertiajs/react"
import { Card } from "@/components/ui/card"
import { PageLayout } from "@/components/VocationalTest/PageLayout"
import { FileText, Mail, MapPin, ArrowLeft } from "lucide-react"
import { Button } from "@/components/ui/button"

export default function TermsOfUsePage() {
  return (
    <>
      <Head title="Termos de Uso - Orientação Profissional" />
      <PageLayout>
        <Card className="max-w-4xl mx-auto p-8 md:p-12 bg-white">
          <div className="space-y-8">
            {/* Header */}
            <div className="space-y-4 text-center border-b pb-8">
              <div className="flex items-center justify-center gap-3">
                <FileText className="w-10 h-10 text-primary" />
                <h1 className="text-3xl md:text-4xl font-bold text-foreground">
                  Termos de Uso
                </h1>
              </div>
              <p className="text-lg text-muted-foreground">
                App Orientação Profissional com o 25Método S.E.M.E.A.R.
              </p>
              <p className="text-sm text-muted-foreground">
                Última atualização: Fevereiro de 2026
              </p>
            </div>

            {/* Section 1 */}
            <section className="space-y-4">
              <h2 className="text-2xl font-bold text-foreground">1. Sobre o Aplicativo</h2>
              <p className="text-muted-foreground leading-relaxed">
                O <strong>Orientação Profissional</strong> é um app encomendado pela{" "}
                <strong>25SEGUNDOS DESENVOLVIMENTO E TREINAMENTO</strong> (CNPJ 30.977.264/0001-60),
                que utiliza o Eneagrama e o 25Método S.E.M.E.A.R. para ajudar estudantes a descobrir
                suas vocações e fazer escolhas profissionais mais conscientes.
              </p>
            </section>

            {/* Section 2 */}
            <section className="space-y-4">
              <h2 className="text-2xl font-bold text-foreground">2. Quem Pode Usar</h2>
              <ul className="list-disc list-inside text-muted-foreground space-y-2 ml-4">
                <li>Estudantes <strong>a partir de 14 anos</strong> (1º ano do Ensino Médio)</li>
                <li>
                  <strong>Menores de 18 anos</strong> precisam de autorização dos pais/responsáveis,
                  que deve ser comunicada pela escola
                </li>
              </ul>
            </section>

            {/* Section 3 */}
            <section className="space-y-4">
              <h2 className="text-2xl font-bold text-foreground">3. Como Funciona</h2>
              <p className="text-muted-foreground">Ao se cadastrar, você:</p>
              <ol className="list-decimal list-inside text-muted-foreground space-y-2 ml-4">
                <li>Cria sua conta com dados básicos (nome, e-mail, idade, escola e série)</li>
                <li>Responde ao <strong>Teste Básico</strong> (45 questões) — gratuito</li>
                <li>Pode optar pelo <strong>Teste Avançado</strong> (25 questões) — pago</li>
                <li>Recebe relatórios personalizados sobre seu perfil profissional</li>
              </ol>
            </section>

            {/* Section 4 */}
            <section className="space-y-4">
              <h2 className="text-2xl font-bold text-foreground">4. O Que Você Pode Fazer</h2>
              <div className="space-y-2">
                <p className="text-muted-foreground flex items-start gap-2">
                  <span className="text-green-600">✓</span>
                  <span>Usar o app para autoconhecimento e orientação profissional</span>
                </p>
                <p className="text-muted-foreground flex items-start gap-2">
                  <span className="text-green-600">✓</span>
                  <span>Acessar seus resultados e relatórios</span>
                </p>
                <p className="text-muted-foreground flex items-start gap-2">
                  <span className="text-green-600">✓</span>
                  <span>Compartilhar informações com pais, responsáveis ou orientadores educacionais</span>
                </p>
              </div>
            </section>

            {/* Section 5 */}
            <section className="space-y-4">
              <h2 className="text-2xl font-bold text-foreground">5. O Que Você Não Pode Fazer</h2>
              <div className="space-y-2">
                <p className="text-muted-foreground flex items-start gap-2">
                  <span className="text-red-600">✗</span>
                  <span>Compartilhar sua conta com outras pessoas</span>
                </p>
                <p className="text-muted-foreground flex items-start gap-2">
                  <span className="text-red-600">✗</span>
                  <span>Usar o app para fins comerciais ou ilegais</span>
                </p>
                <p className="text-muted-foreground flex items-start gap-2">
                  <span className="text-red-600">✗</span>
                  <span>Tentar burlar ou hackear o sistema</span>
                </p>
                <p className="text-muted-foreground flex items-start gap-2">
                  <span className="text-red-600">✗</span>
                  <span>Fornecer informações falsas</span>
                </p>
              </div>
            </section>

            {/* Section 6 */}
            <section className="space-y-4">
              <h2 className="text-2xl font-bold text-foreground">6. Compras e Pagamentos</h2>
              <ul className="list-disc list-inside text-muted-foreground space-y-2 ml-4">
                <li>O <strong>Teste Básico</strong> é gratuito</li>
                <li>O <strong>Teste Avançado</strong> e outros produtos (livros, cursos, mentorias) são opcionais e pagos</li>
                <li>Pagamentos são processados por plataformas seguras de terceiros</li>
                <li>Verifique a política de cancelamento e reembolso no momento da compra</li>
              </ul>
            </section>

            {/* Section 7 */}
            <section className="space-y-4">
              <h2 className="text-2xl font-bold text-foreground">7. Propriedade Intelectual</h2>
              <ul className="list-disc list-inside text-muted-foreground space-y-2 ml-4">
                <li>
                  O 25Método S.E.M.E.A.R., o conteúdo do app e os relatórios são de propriedade da{" "}
                  <strong>25SEGUNDOS</strong>
                </li>
                <li>
                  Você pode usar os resultados para fins pessoais, mas não pode reproduzir ou
                  comercializar o conteúdo
                </li>
              </ul>
            </section>

            {/* Section 8 */}
            <section className="space-y-4">
              <h2 className="text-2xl font-bold text-foreground">8. Responsabilidades</h2>
              <p className="text-muted-foreground font-semibold">
                O app oferece orientação vocacional, mas:
              </p>
              <ul className="list-disc list-inside text-muted-foreground space-y-2 ml-4">
                <li>Não substitui aconselhamento profissional individual</li>
                <li>As decisões finais sobre carreira são suas (e de seus responsáveis, se menor)</li>
                <li>A 25SEGUNDOS não se responsabiliza por escolhas feitas com base nos resultados</li>
              </ul>
            </section>

            {/* Section 9 */}
            <section className="space-y-4">
              <h2 className="text-2xl font-bold text-foreground">9. Modificações</h2>
              <p className="text-muted-foreground">
                Podemos atualizar estes Termos de Uso. Você será notificado por e-mail sobre mudanças
                importantes.
              </p>
            </section>

            {/* Section 10 */}
            <section className="space-y-4">
              <h2 className="text-2xl font-bold text-foreground">10. Cancelamento de Conta</h2>
              <p className="text-muted-foreground">
                Você pode solicitar o cancelamento da sua conta a qualquer momento através do e-mail:{" "}
                <strong>atendimento@25segundos.com.br</strong>
              </p>
            </section>

            {/* Section 11 */}
            <section className="space-y-4">
              <h2 className="text-2xl font-bold text-foreground">11. Contato</h2>
              <div className="bg-accent/10 rounded-lg p-4 space-y-2">
                <p className="font-semibold text-foreground">
                  25SEGUNDOS DESENVOLVIMENTO E TREINAMENTO
                </p>
                <div className="flex items-center gap-2 text-muted-foreground">
                  <MapPin className="w-4 h-4" />
                  <span>Rua Curitiba, 160 – Bairro Nova Mogi – Mogi Mirim/SP  – CEP 13800-310</span>
                </div>
                <div className="flex items-center gap-2 text-muted-foreground">
                  <Mail className="w-4 h-4" />
                  <span>atendimento@25segundos.com.br</span>
                </div>
              </div>
            </section>

            {/* Section 12 */}
            <section className="space-y-4">
              <h2 className="text-2xl font-bold text-foreground">12. Lei Aplicável</h2>
              <p className="text-muted-foreground">
                Estes Termos são regidos pelas leis brasileiras, especialmente:
              </p>
              <ul className="list-disc list-inside text-muted-foreground space-y-1 ml-4">
                <li>Lei Geral de Proteção de Dados (LGPD - Lei 13.709/2018)</li>
                <li>Código de Defesa do Consumidor</li>
                <li>Marco Civil da Internet</li>
              </ul>
            </section>

            {/* Footer */}
            <div className="border-t pt-8 space-y-4">
              <p className="text-center text-muted-foreground font-medium">
                Ao usar o app, você declara ter lido e concordado com estes Termos de Uso.
              </p>
              <div className="flex justify-center gap-4 pt-4">
                <Link href="/politica-de-privacidade">
                  <Button variant="outline" className="gap-2">
                    Ver Política de Privacidade
                  </Button>
                </Link>
                <Link href="/">
                  <Button variant="outline" className="gap-2">
                    <ArrowLeft className="w-4 h-4" />
                    Voltar ao início
                  </Button>
                </Link>
              </div>
            </div>
          </div>
        </Card>
      </PageLayout>
    </>
  )
}